// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/search-result.css
// module id = 287
// module chunks = 2